import { Modal } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { MForm } from "src/components/MForm";
import { MFormStore } from "src/components/MForm/MFormStore";

type PropsFormPreviewModal = {
  store: MFormStore | null;
  close(): void;
};

export const FormPreviewModal: React.FC<PropsFormPreviewModal> = observer(
  (props) => {
    const { store, close } = props;
    return (
      <Modal
        open={!!store}
        onCancel={close}
        title="Тестовый просмотр формы"
        width={800}
        centered
        footer={null}
      >
        <div style={{ overflow: "auto", maxHeight: "80vh" }}>
          {!!store && <MForm store={store} />}
        </div>
      </Modal>
    );
  },
);
